const ProgramCardsSchema = () => ({
  title: 'AgSUS Program Cards',
  fieldsets: [
    { id: 'default', title: 'Seção', fields: ['eyebrow', 'title', 'columns'] },
    { id: 'items', title: 'Programas', fields: ['items'] },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título' },
    columns: {
      title: 'Colunas',
      choices: [['2', '2'], ['3', '3']],
      default: '2',
    },
    items: {
      title: 'Programas',
      widget: 'object_list',
      schema: {
        title: 'Programa',
        fieldsets: [{ id: 'default', title: 'Default', fields: ['acronym', 'title', 'description', 'meta', 'status', 'href'] }],
        properties: {
          acronym: { title: 'Sigla/Acrônimo (ex: MM, ATE)' },
          title: { title: 'Nome do programa' },
          description: { title: 'Descrição', widget: 'textarea' },
          meta: { title: 'Meta (ex: "Desde 2013 · 18 mil profissionais")' },
          status: {
            title: 'Status',
            choices: [['ativo', 'Ativo'], ['encerrado', 'Encerrado'], ['standby', 'Stand-by']],
            default: 'ativo',
          },
          href: { title: 'Link' },
        },
        required: ['title'],
      },
    },
  },
  required: [],
});
export default ProgramCardsSchema;
